import React, { Component } from 'react';
import {Modal} from 'react-bootstrap';

class OrgNameAlreadyExistsErrorModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			orgJoinResponseMessage: ""
		};
	}

	componentDidMount() {

	}

	handleOK = (event) => {
		this.props.hideOrgNameAlreadyExistsErrorModal();
	}

	render () {

		return (
			<Modal onHide={this.props.hideOrgNameAlreadyExistsErrorModal} show={this.props.showOrgNameAlreadyExistsErrorModal} aria-labelledby="ModalHeader">
            	<Modal.Header closeButton>
              		<Modal.Title id='ModalHeader'>FirstNet Developer Program</Modal.Title>
            	</Modal.Header>
            	<Modal.Body>
					An Organization with this name already exists. If you do not want to join the 
					existing Organization, please change the name.
            	</Modal.Body>
            	<Modal.Footer>
              		<button className='button secondary light-bg' onClick={this.handleOK} name="OK">
                		OK
              		</button>  
            	</Modal.Footer>
          </Modal>
		)
	}
}

export default OrgNameAlreadyExistsErrorModal;



// WEBPACK FOOTER //
// ./src/manageOrg/OrgNameAlreadyExistsErrorModal.js